// /* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Detalle from './detalle';
import Salida from './salida';
import './paquete.css';

class Paquete extends Component {
  static armarInfoAerolinea(transporte) {
    const elemento = '';
    if (transporte.img === 'Aerolineas Argentinas') {
      return (
        <div className='texto-transporte'>
          Viajando por:
          {' '}
          <b className='inline-block'>
            {' '}
            {transporte.nombreTransporte}
          </b>
        </div>
      );
    }
    if (transporte.img.length > 3) {
      return (
        <div className='padding-bottom transporte-paquete'>
          <img src={transporte.img} title={transporte.nombreTransporte} alt={transporte.nombreTransporte} className='img-responsive' height='35px' width='85px' />
        </div>
      );
    }
    if (transporte.nombreTransporte.length > 1) {
      return (
        <div className='texto-transporte'>
          Viajando por:
          {' '}
          <b className='inline-block'>
            {' '}
            {transporte.nombreTransporte}
          </b>
        </div>
      );
    }
    return elemento;
  }

  constructor(props) {
    super(props);
    this.state = {
      isOpenMoreDepartures: false,
    };
    this.ArmarSalidas = this.ArmarSalidas.bind(this);
    this.formatearPrecio = this.formatearPrecio.bind(this);
    this.transporteElemento = this.transporteElemento.bind(this);
    this.armarTitulo = this.armarTitulo.bind(this);
  }

  ArmarSalidas() {
    const listaSalidas = [];
    if (!this.props.salidas) {
      return listaSalidas;
    }
    if (this.props.salidas.length < 3) {
      return listaSalidas;
    }

    let cantPasajeros;

    for (let i = 2; i < this.props.salidas.length; i++) {
      cantPasajeros = (this.props.paquete.pasajeros.length > 0)
        ? this.props.paquete.pasajeros.length
        : this.props.cantidadPasajeros;
      listaSalidas.push(
        <Salida
          idProducto={this.props.paquete.idProducto}
          title={this.armarTitulo()}
          cupos={this.props.cupos}
          proveedorId={this.props.paquete.proveedorId}
          distribucion={this.props.distribucion}
          indice={i}
          salidas={this.props.paquete.salidas}
          formatearPrecio={this.formatearPrecio}
          cant_pasajeros={cantPasajeros}
          key={i}
          hoteles={this.props.salidas[i].hoteles}
          datos={this.props.paquete.salidas[i]}
          nroComb={this.props.paquete.nroComb}
        />,
      );
    }
    return listaSalidas;
  }

  ArmarSalidaUnica() {
    const listaSalidas = [];
    if (!this.props.salidas) {
      return listaSalidas;
    }
    if (this.props.salidas.length < 2) {
      return listaSalidas;
    }

    const cantPasajeros = (this.props.paquete.pasajeros.length > 0)
      ? this.props.paquete.pasajeros.length
      : this.props.cantidadPasajeros;

    listaSalidas.push(
      <Salida
        idProducto={this.props.paquete.idProducto}
        title={this.armarTitulo()}
        cupos={this.props.cupos}
        proveedorId={this.props.paquete.proveedorId}
        distribucion={this.props.distribucion}
        indice={1}
        salidas={this.props.paquete.salidas}
        formatearPrecio={this.formatearPrecio}
        cant_pasajeros={cantPasajeros}
        key='fist-package'
        hoteles={this.props.salidas[1].hoteles}
        datos={this.props.paquete.salidas[1]}
        nroComb={this.props.paquete.nroComb}
      />,
    );
    return listaSalidas;
  }

  formatearPrecio(precioNeto, impuestos, impuestoPais, iva, cantPasajeros) {
    const precioRedondeado = Math.ceil((precioNeto + impuestos + impuestoPais + iva) / cantPasajeros);
    return this.formatNumber(precioRedondeado);
  }

  formatNumber = (num) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  }

  transporteElemento() {
    const datos = this.props.paquete;
    let img = '';
    let nombreTransporte = '';

    // Valida proveedor Allseasons
    if (datos.proveedorId === 3 || datos.proveedorId === 1) {
      if (datos.salidas[0].transporte.transporteAereo !== null) {
        img = datos.salidas[0].transporte.transporteAereo.imagen === null || datos.salidas[0].transporte.transporteAereo.imagen === undefined
          ? ''
          : datos.salidas[0].transporte.transporteAereo.imagen;
        nombreTransporte = datos.salidas[0].transporte.transporteAereo.nombreLineaAerea === null || datos.salidas[0].transporte.transporteAereo.nombreLineaAerea === undefined
          ? ''
          : datos.salidas[0].transporte.transporteAereo.nombreLineaAerea;
      }
    } else if (datos.salidas[0].transporte.transporteAereo !== null) {
      img = datos.salidas[0].transporte.transporteAereo.imagen === null || datos.salidas[0].transporte.transporteAereo.imagen === undefined
        ? ''
        : datos.salidas[0].transporte.transporteAereo.imagen;
      nombreTransporte = datos.salidas[0].transporte.transporteAereo.nombreLineaAerea === null || datos.salidas[0].transporte.transporteAereo.nombreLineaAerea === undefined
        ? ''
        : datos.salidas[0].transporte.transporteAereo.nombreLineaAerea;
    }

    const transporte = {
      img,
      nombreTransporte,
    };

    return Paquete.armarInfoAerolinea(transporte);
  }

  armarTitulo() {
    const indexBr = this.props.paquete.nombre.indexOf('<br>');
    if (indexBr === -1) {
      return this.props.paquete.nombre;
    }
    return this.props.paquete.nombre.substr(0, indexBr);
  }

  toggleMoreDepartures = () => this.setState((prev) => ({
    ...prev,
    isOpenMoreDepartures: !prev.isOpenMoreDepartures,
  }));

  render() {
    const { isOpenMoreDepartures } = this.state;
    const primeraSalidaAlternativa = this.ArmarSalidaUnica();
    const salidasListaComponentes = this.ArmarSalidas();
    const { t } = this.props;
    return (
      <div>
        <div className='panel panel-default custom paquete overflow-hidden mb-2'>
          <div className='paquete bg-white'>
            <Detalle
              title={this.armarTitulo()}
              cantidadPasajeros={this.props.cantidadPasajeros}
              cupos={this.props.cupos}
              proveedorId={this.props.paquete.proveedorId}
              distribucion={this.props.distribucion}
              formatearPrecio={this.formatearPrecio}
              salidas={this.props.salidas}
              paquete={this.props.paquete}
              indice={this.props.indice}
            />
            <div className='hidden col-xs-12'>
              {this.transporteElemento()}
            </div>
            <div className='clearfix' />
          </div>
          <div className='clearfix' />
          <div className='panel-inferior'>
            <div className='primera-salida'>
              { primeraSalidaAlternativa.length > 0
                && primeraSalidaAlternativa}
            </div>
            <div className='clearfix' />
          </div>
          <div className='clearfix' />
          <div className='lista-salidas'>
            <div className={`panel-collapse collapse ${isOpenMoreDepartures ? 'block' : 'hidden'}`}>
              {salidasListaComponentes.length > 0 && (
                salidasListaComponentes
              )}
            </div>
          </div>
          { salidasListaComponentes.length > 0 && (
            <div className='btn-ver-mas-salidas'>
              <button
                onClick={this.toggleMoreDepartures}
                type='button'
                className='btn-ver-mas-salidas-toggle'
              >
                {isOpenMoreDepartures
                  ? (
                    <React.Fragment>
                      <i className='fa fa-chevron-up' aria-hidden='true' />
                      {' Ocultar'}
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <i className='fa fa-chevron-down' aria-hidden='true' />
                      {` Ver las ${salidasListaComponentes.length} salidas disponibles`}
                    </React.Fragment>
                  )}
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default (withTranslation(['translations'])(Paquete));
